module.exports = __webpack_public_path__ + "static/img/RAOK-1T_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOK-1T_1.png
// module id = Dec4
// module chunks = 0